/**
 * @generated SignedSource<<c985f8d6324085ca69406ce115f60e69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contextsSeriesWidgetContextProviderArticle$data = {
  readonly seriesContainer: {
    readonly headline: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetEntrypointHeadlineArticle">;
  readonly " $fragmentType": "contextsSeriesWidgetContextProviderArticle";
};
export type contextsSeriesWidgetContextProviderArticle$key = {
  readonly " $data"?: contextsSeriesWidgetContextProviderArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"contextsSeriesWidgetContextProviderArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contextsSeriesWidgetContextProviderArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "seriesWidgetEntrypointHeadlineArticle"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "c10aa50ea2b16895a37d8f1475a469e5";

export default node;
